/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<path pid="0" d="M22.7 8.6c0-2.9-2.4-5.3-5.3-5.3S12 5.7 12 8.6s2.4 5.3 5.3 5.3 5.4-2.3 5.4-5.3zm2 0c0 4-3.3 7.3-7.3 7.3S10 12.7 10 8.6s3.3-7.3 7.3-7.3 7.4 3.3 7.4 7.3zM19.1 22.2h-4.2c-4.9 0-9 3.7-9.5 8.5h23.2c-.5-4.8-4.6-8.5-9.5-8.5zm10.6 10.5H4.3c-.6 0-1-.4-1-1 0-6.4 5.2-11.5 11.6-11.5h4.2c6.4 0 11.6 5.2 11.6 11.5 0 .6-.5 1-1 1z"/>'
  }
})
